module.exports = __webpack_public_path__ + "assets/bell-small-active.1a757a8e.svg";